(function() {
  if (window.BOGO_RESTRICTION_LOADED) return;
  window.BOGO_RESTRICTION_LOADED = true;

  var BOGO_IDS = window.BOGO_PRODUCT_IDS || [];
  var MYSTERY_BOX_ID = window.MYSTERY_BOX_PRODUCT_ID || 8093507649610;
  var _cartData = null;
  var _cartLoaded = false;
  var _refreshTimer = null;

  var _lsKey = 'bogo:cart:ts';

  function getCurrentProductId() {
    var id = document.body.getAttribute('data-current-product-id');
    return id ? parseInt(id, 10) : null;
  }

  function isCurrentProductMysteryBox() { return getCurrentProductId() === MYSTERY_BOX_ID; }

  function isCurrentProductRestricted() {
    var id = getCurrentProductId();
    return id && BOGO_IDS.indexOf(id) !== -1;
  }

  function isRelevantPage() { return isCurrentProductMysteryBox() || isCurrentProductRestricted(); }

  function getRestrictedMessage() {
    if (isCurrentProductMysteryBox())
      return 'Mystery Box are not eligible with presale items in cart. Please remove presale items to purchase Mystery Box.';
    return 'Presale items are not eligible for purchase with Mystery Box. Please remove Mystery Box from your cart to purchase this item.';
  }

  function isRestricted() {
    if (!_cartData) return false;
    if (isCurrentProductMysteryBox())
      return _cartData.items.some(function(item) { return BOGO_IDS.indexOf(item.product_id) !== -1; });
    if (isCurrentProductRestricted())
      return _cartData.items.some(function(item) { return item.product_id === MYSTERY_BOX_ID; });
    return false;
  }

  function broadcastCartChange() {
    try { localStorage.setItem(_lsKey, Date.now().toString()); } catch(e) {}
  }

  function updateCartState() {
    return fetch('/cart.js', { cache: 'no-store' }).then(function(r) { return r.json(); }).then(function(cart) {
      _cartData = cart;
      _cartLoaded = true;
    }).catch(function(e) { console.error('BOGO: cart fetch failed', e); });
  }

  function showError(msg) {
    var container = document.querySelector('.product-form__error-message-wrapper');
    if (container) {
      container.removeAttribute('hidden');
      var el = container.querySelector('.product-form__error-message');
      if (el) el.textContent = msg;
    }
  }

  function applyUI() {
    if (!isRelevantPage()) return;
    var btn = document.querySelector('.product-form__submit');
    var buttons = document.querySelector('.product-form__buttons');
    var note = document.getElementById('bogo-restriction-note');
    var restricted = _cartLoaded && isRestricted();

    if (!note && buttons) {
      note = document.createElement('div');
      note.id = 'bogo-restriction-note';
      note.style.cssText = 'padding:12px 16px;background:#fff3cd;border:1px solid #ffeeba;border-radius:4px;color:#856404;font-size:14px;margin:10px 0;text-align:center;';
      note.textContent = getRestrictedMessage();
      buttons.parentNode.insertBefore(note, buttons);
    }
    if (note && note.textContent !== getRestrictedMessage()) note.textContent = getRestrictedMessage();

    if (restricted) {
      if (buttons) buttons.style.display = 'none';
      if (btn) { btn.disabled = true; btn.setAttribute('aria-disabled', 'true'); }
      if (note) note.style.display = 'block';
    } else {
      if (buttons) buttons.style.display = '';
      if (btn) { btn.disabled = false; btn.removeAttribute('aria-disabled'); }
      if (note) note.style.display = 'none';
    }
  }

  function refresh() {
    if (_refreshTimer) return;
    _refreshTimer = setTimeout(function() {
      _refreshTimer = null;
      updateCartState().then(applyUI);
    }, 200);
  }

  document.addEventListener('submit', function(e) {
    var form = e.target;
    if (!form || !form.action) return;
    if (form.action.indexOf('/cart/add') === -1 && (!window.routes || form.action.indexOf(window.routes.cart_add_url) === -1)) return;
    if (_cartLoaded && isRestricted()) {
      e.preventDefault();
      e.stopPropagation();
      showError(getRestrictedMessage());
    }
  }, true);

  var origFetch = window.fetch;
  if (origFetch) {
    window.fetch = function(input, init) {
      var url = typeof input === 'string' ? input : (input && input.url ? input.url : '');
      var isCartWrite = url && (url.indexOf('/cart/add') !== -1 || url.indexOf('/cart/change') !== -1 || url.indexOf('/cart/update') !== -1);
      if (url && (url.indexOf('/cart/add') !== -1 || (window.routes && window.routes.cart_add_url && url.indexOf(window.routes.cart_add_url) !== -1))) {
        if (_cartLoaded && isRestricted()) {
          var msg = getRestrictedMessage();
          return Promise.resolve(new Response(JSON.stringify({
            status: 422,
            description: msg,
            message: msg
          }), {
            status: 422,
            statusText: 'Unprocessable Entity',
            headers: { 'Content-Type': 'application/json' }
          }));
        }
      }
      var result = origFetch.call(this, input, init);
      if (isCartWrite) {
        result.then(function(r) {
          if (r.ok || r.status === 200) { broadcastCartChange(); refresh(); }
          return r;
        });
      }
      return result;
    };
  }

  var origOpen = XMLHttpRequest.prototype.open;
  if (origOpen) {
    XMLHttpRequest.prototype.open = function(method, url) {
      this._bogoUrl = typeof url === 'string' ? url : (url ? url.toString() : '');
      return origOpen.apply(this, arguments);
    };
    var origSend = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.send = function() {
      var xhr = this;
      var url = xhr._bogoUrl || '';
      if (url && (url.indexOf('/cart/add') !== -1 || url.indexOf('/cart/change') !== -1 || url.indexOf('/cart/update') !== -1)) {
        if ((url.indexOf('/cart/add') !== -1) && _cartLoaded && isRestricted()) {
          xhr._bogoBlocked = true;
        }
        xhr.addEventListener('load', function() {
          if (xhr.status >= 200 && xhr.status < 300 && !xhr._bogoBlocked) {
            broadcastCartChange();
            refresh();
          }
        });
      }
      return origSend.apply(this, arguments);
    };
  }

  window.addEventListener('storage', function(e) {
    if (e.key === _lsKey) refresh();
  });

  function init() {
    refresh();
    document.addEventListener('cart:updated', refresh);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
